import axios from 'axios';

import { decryptData } from '@/components/reusable/crypto/Cipher';
import Cookies from 'js-cookie';
import { API } from './config';
import { UAParser } from 'ua-parser-js';
import { getDeviceFingerprint } from '@/utils/getDeviceFingerprint';
const role = Cookies.get('role');
const auth = {
  signIn: async (url, { mobileNumber, password }) => {
    const parser = new UAParser();
    const result = parser.getResult();
    const defaultDeviceName = `${result.device.model || result.browser.name} (${result.os.name} ${result.os.version})`;
    const deviceId = await getDeviceFingerprint();
    return axios.post(
      `${import.meta.env.VITE_APP_API_URL}/${url}`,
      { deviceId, mobileNumber, password, defaultDeviceName },
      {
        auth: {
          username: mobileNumber,
          password: password,
          defaultDeviceName,
          deviceId,
        },
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json',
          credentials: 'include',
        },
      },
    );
  },

  signUp: async (values) => {
    return await axios.post(
      `${import.meta.env.VITE_APP_API_URL}/register/`,
      values,
    );
  },

  logout: async () => {
    const token = decryptData(Cookies.get('token'));
    const branchCode = Cookies.get('branchCode');
    const companyCode = Cookies.get('companyCode');
    return await axios.post(
      `${import.meta.env.VITE_APP_API_URL}/logout/`,
      {},
      {
        headers: {
          Authorization: `token ${token}`,
          Branch: branchCode,
          Company: companyCode,
        },
      },
    );
  },
};

const adminAuth = {
  logout: async (role) => {
    return await API.post(
      role === 'superadmin' ? 'superadmin/logout/' : 'admin/logout/',
    );
  },
};

export { adminAuth, auth };
